import React, { Component} from 'react'
import { connect } from 'react-redux'
import { userService } from '../../services/user.service'
import { Row, Col, Container, Form, Button } from 'react-bootstrap'
import Spinner from 'react-bootstrap/Spinner'
import { validateEmail } from '../../lib/helpers/helpers'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'

class Login extends Component {
    constructor(props){
        super(props)
        userService.logout();
        this.state = {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            errorLogin: ''
        }

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(e){
        const { name, value } = e.target
        return this.setState({ [name]: value })
    }

    handleSubmit(){

        this.setState({ submitted: true });
        const { username, password } = this.state;

        if (!(username && password )) {
            return alert("Sin datos")
        }
        if(validateEmail(username) !== true) return toast.error('Email inválido')

        this.setState({ loading: true });
        userService.login(username, password )
            .then(
                user => {
                    if(!user){
                        this.setState({ errorLogin: "Email o Contraseña erroneas", loading: false })
                    } else {
                    const { from } = this.props.location.state || { from: { pathname: "/" } };
                    this.props.history.push(from);
                    }
                    
                },
                error => this.setState({ error, loading: false })
            );
    }
    
    render(){
        const { loading, errorLogin } = this.state
        return(
            <Container style={{ backgroundColor:'black' }}>
                
        <Row className="justify-content-md-center">
            <Col md={4} className="centerv">
            <img alt="logotipo" src="images/logo.png" style={{ width: 200 }} />

                <h4>Bienvenido de vuelta, Inicia sesión</h4>

            <Form.Group >
    <Form.Control type="email" name="username" placeholder="Email" onChange={this.handleChange} />
    </Form.Group>

  <Form.Group >
    <Form.Control type="password" name="password" placeholder="Contraseña" onChange={this.handleChange} />
    
  </Form.Group>

  <Form.Group >  
    { loading ? <Spinner animation="border" /> : <Button onClick={() => this.handleSubmit() }  block variant="primary">ENTRAR</Button> }  
            { errorLogin ? <p className="text-danger">{errorLogin}</p> : false }
  </Form.Group>

            </Col>
        </Row>

        
        
    </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        miusuario: state.miusuario
    }
}

export default connect(mapStateToProps)(Login);